import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgStylingComponentsModule } from '@libs/frameworks/angular';

import { UiDarkModeComponent } from './dark-mode/dark-mode.component';
import { UiFullscreenComponent } from './fullscreen/fullscreen.component';


@NgModule({
	declarations: [
		UiDarkModeComponent,
		UiFullscreenComponent
	],
	imports		: [
		CommonModule,
		NgbDropdownModule,
		NgStylingComponentsModule
	],
	exports		: [
		UiDarkModeComponent,
		UiFullscreenComponent
	]
})
export class UiHeaderComponentsModule {}
